import { APP_LICENSE } from '../GetGlobalProps';
import useGlobalVariables from '../hooks/useGlobalVariables';
import { VINCI_SUPPORT_EMAIL } from './Constants';
import getJWT from './getJWT';

const licenseMapping = {
  'nav-btn-welcome': [APP_LICENSE.OT, APP_LICENSE.AML],
  'nav-btn-forms': [APP_LICENSE.OT],
  'nav-btn-users': [APP_LICENSE.OT, APP_LICENSE.AML],
  'nav-btn-reports': [APP_LICENSE.OT],
  'nav-btn-new_reports': [APP_LICENSE.OT],
  'nav-btn-audit': [APP_LICENSE.OT, APP_LICENSE.AML],
  'nav-btn-settings': [APP_LICENSE.OT],
  'nav-btn-aml-responses': [APP_LICENSE.AML],

  'admin-grid-back-button': [APP_LICENSE.OT],
  'admin-grid-overview-edit-btn': [APP_LICENSE.OT],

  'users-groups-tab': [APP_LICENSE.OT]
};

export const isIncludedInLicense = componentId => {
  const { licenseType: _licenseType } = useGlobalVariables();

  const isVinciSupport =
    ((getJWT() || {}).userProfile || {}).email === VINCI_SUPPORT_EMAIL;

  const licenseType = isVinciSupport ? APP_LICENSE.OT : _licenseType;

  return !!(licenseMapping[componentId] || []).includes(licenseType);
};
